module.exports = __webpack_public_path__ + "static/media/dyno-cover.4c07c54c.jpg";